<div class="page-color-padding package-tab">
  <div class="row medium">
    <div class="col-md-12">
      <h2 class="pageTitle" data-testid="pkgManagementTitle">Package Management</h2>
      <h6 class="packages-subtext" data-testid="pkgSubTxt">
        View details for this package, assign and unassign users as needed.
      </h6>
    </div>
  </div>
  <div class="row margin-bottom-10">
    <div class="col-md-8">
      <h2 class="sectionTitle">Package Details</h2>
    </div>
    <div class="col-md-4 text-right margin-top-4">
      <span class="pad-top-10">
        @if (canShowChangePackageMix) {
          <rw-button
            id="btnChangePackageMix"
            arialabel="Change Seat Count button"
            datapendoid="change-seat-count-button"
            datatestid="change-seat-count-button"
            sizeclass="btn-sm"
            buttonclass="rw-btn-primary"
            [disable]="orgIsInAddOnSuspended"
            text="CHANGE SEAT COUNT"
            placement="top"
            [rw-tooltip]="addOnSuspendedTooltip"
            tt_datatestid="change-seat-count-tooltip"
            tt_datapendoid="change-seat-count-tooltip"
            tt_arialabel="change seat count button tooltip"
            (clickButton)="changePackageMix()"
          >
          </rw-button>
        }
      </span>
    </div>
  </div>
  <h6 class="packages-subtext">
    {{ CustomerTypePackageText }}
  </h6>
  <div class="button-margin">
    @if (!canShowChangePackageMix) {
      <div class="step-desc">{{ infoText }}</div>
    }
    <div class="no-padding well table-intuit-container no-side-margins">
      <table show-filter="false" class="table-package-detail table-packages">
        <thead>
          <tr>
            <th data-testid="pkgType" class="orgPackageTableNameColumn">Type</th>
            <th data-testid="pkgSeats" class="packageCells">Seats</th>
            <th data-testid="pkgAssigned" class="packageCells">Assigned</th>
            <th data-testid="pkgRemaining" class="packageCells">Remaining</th>
          </tr>
        </thead>
        <tr>
          <td data-testid="pkgName">{{ PackagePool?.PackageName }}</td>
          <td class="packageCells">
            <span data-testid="pkgSeatsNumber">{{ PackagePool?.NumberAllowed }}</span>
          </td>
          <td class="packageCells">
            <span data-testid="pkgAssignedNumber">{{ PackagePool?.NumberUsed }}</span>
          </td>
          <td class="packageCells">
            <span data-testid="pkgRemainingNumber">{{ RemainingAmount }}</span>
          </td>
        </tr>
      </table>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12">
      <div class="btn-group">
        <h2 class="sectionTitle disp-inl-flex">Users assigned to {{ PackagePool?.PackageName }}</h2>
        &nbsp;<app-icon
          source="rn-help"
          [imgClass]="'questionMarkTooltip'"
          placement="right"
          tt_datatestid="packagemanagement-help-tooltip"
          tt_datapendoid="packagemanagement-help-tooltip"
          tt_arialabel="Package management help tooltip"
          [rw-tooltip]="packageAssignTooltip"
        ></app-icon>
      </div>
      @if (canShowAssignRemove) {
        <div class="btn-group pull-right margin-top-4">
          <div class="display-flex">
            <span class="pull-right assignPackageSpan"
              ><rw-button
                id="btnAssign"
                buttonclass="rw-btn-primary"
                arialabel="Assign package button"
                datapendoid="assign-package-button"
                datatestid="assign-package-button"
                sizeclass="btn-sm"
                [disable]="isEntitlementCompletelyConsumed"
                text="ASSIGN PACKAGE TO USERS"
                (clickButton)="AssignPackage()"
              >
              </rw-button
            ></span>
            <span class="pull-right"
              ><rw-button
                id="btnRemove"
                buttonclass="rw-btn-secondary"
                arialabel="Remove package button"
                datapendoid="remove-package-button"
                datatestid="remove-package-button"
                sizeclass="btn-sm"
                [disable]="SelectedUsersForRemoval.length === 0"
                text="REMOVE PACKAGE FROM USERS"
                (clickButton)="removeSelectedPackages()"
              >
              </rw-button
            ></span>
          </div>
        </div>
      }
    </div>
  </div>
  <div class="row medium">
    <div class="col-md-12">
      <div>
        <rn-grid
          [Configuration]="TableConfiguration"
          [(selection)]="SelectedUsersForRemoval"
          (rowSelected)="rowSelected($event)"
          [clearSelected]="clearSelection.asObservable()"
        ></rn-grid>
      </div>
    </div>
    <span class="returnToInventorySpan"
      ><rw-button
        id="btnReturn"
        arialabel="Return to inventory button"
        datapendoid="return-to-inventory-button"
        datatestid="return-to-inventory-button"
        sizeclass="btn-md"
        (clickButton)="returnToInventory()"
        text="RETURN TO INVENTORY"
        buttonclass="rw-btn-secondary"
      >
      </rw-button
    ></span>
  </div>
</div>
